(function headerMenu() {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "modal";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


  const ctaModals = document.querySelectorAll('[data-open]');
  ctaModals.forEach(ctaModal => {
    ctaModal.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        this.click();
      }
    });
  });

    $(() => {
  })

})()
